module.exports = __webpack_public_path__ + "static/default_back-cebeb6304a80fc204cb975abcb6e5b9c.jpg";